import { Controller } from "@hotwired/stimulus"
import { LibraryProviders } from "web/Providers"
import { Loading, ModalContainer } from "web/components"
import { ModalsProvider } from "web/contexts"
import { render } from "react-dom"
import { useAsset } from "web/hooks/data"
import LocationList from "web/app/Assets/AssetLocation/LocationList"
import React, { Suspense } from "react"

export default class LocationListController extends Controller {
  static values = {
    assetId: Number,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const LocationListWrapper = () => {
      return <LocationList asset={useAsset(this.assetIdValue)} />
    }

    render(
      <Suspense fallback={<Loading />}>
        <LibraryProviders>
          <ModalsProvider>
            <LocationListWrapper />
            <ModalContainer />
          </ModalsProvider>
        </LibraryProviders>
      </Suspense>,
      this.element
    )
  }
}
